import React from 'react';
import { COMUNI } from '../../constants';

const ProfileDetailsForm = ({
  azienda,
  onChange,
  onSubmit,
  useComuniSelect = false,
  isSubmitting = false,
}) => (
  <form onSubmit={onSubmit}>
    <div>
      <label htmlFor="nomeAzienda">Nome Azienda:</label>
      <input
        id="nomeAzienda"
        type="text"
        name="nomeAzienda"
        value={azienda.nomeAzienda || ''}
        onChange={onChange}
      />
    </div>
    <div>
      <label htmlFor="descrizione">Descrizione:</label>
      <input
        id="descrizione"
        type="text"
        name="descrizione"
        value={azienda.descrizione || ''}
        onChange={onChange}
      />
    </div>
    <div>
      <label htmlFor="comune">Comune:</label>
      {useComuniSelect ? (
        <select
          id="comune"
          name="comune"
          value={azienda.comune || ''}
          onChange={onChange}
        >
          <option value="">Seleziona un comune</option>
          {COMUNI.map((c) => (
            <option key={c.nome} value={c.nome}>
              {c.nome}
            </option>
          ))}
        </select>
      ) : (
        <input
          id="comune"
          type="text"
          name="comune"
          value={azienda.comune || ''}
          onChange={onChange}
        />
      )}
    </div>
    <div>
      <label htmlFor="indirizzo">Indirizzo:</label>
      <input
        id="indirizzo"
        type="text"
        name="indirizzo"
        value={azienda.indirizzo || ''}
        onChange={onChange}
      />
    </div>
    <div>
      <label htmlFor="partitaIva">Partita IVA:</label>
      <input
        id="partitaIva"
        type="text"
        name="partitaIva"
        value={azienda.partitaIva || ''}
        onChange={onChange}
      />
    </div>
    <div>
      <label htmlFor="telefono">Telefono:</label>
      <input
        id="telefono"
        type="tel"
        name="telefono"
        value={azienda.telefono || ''}
        onChange={onChange}
      />
    </div>
    {azienda.tipologiaAzienda !== 'Tradizioni' && (
      <div>
        <label htmlFor="iban">IBAN:</label>
        <input
          id="iban"
          type="text"
          name="iban"
          value={azienda.iban || ''}
          onChange={onChange}
        />
      </div>
    )}
    <button type="submit" disabled={isSubmitting}>
      {isSubmitting ? 'Salvataggio...' : 'Salva'}
    </button>
  </form>
);

export default ProfileDetailsForm;
